import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from "@angular/router";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private sessionSt: LocalStorageService, private router: Router) { }

  ngOnInit(): void {
    this.sessionSt.clear();
    this.router.navigateByUrl("/");
  }

}
